import { useMutation } from 'react-query';
import apiFetch from 'react-scale/lib/api-fetch';
import { SquadMemberRole } from '@scale/shared/types/expertManagement';

type AddWorkersToSquadProps = {
  squadId: string;
  workerIds: string[];
  role: SquadMemberRole;
  createDiscourseCommunityChannel?: boolean;
};

export const useAddWorkersToSquad = () => {
  return useMutation(
    [`addWorkersToSquads`],
    ({ squadId, workerIds, role, createDiscourseCommunityChannel }: AddWorkersToSquadProps) =>
      apiFetch(null, `internal/expert-management/addWorkersToSquad`, {
        method: 'POST',
        body: {
          squadId,
          workerIds,
          role,
          createDiscourseCommunityChannel,
        },
      }),
  );
};
